import React, { useRef, useState, useEffect } from "react";
import SaveButton from "../../../components/SaveButton";
import CancelButton from "../../../components/CancelButton";
import ProdCodeFormCarrierSection from "./ProdCodeFormCarrierSection";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import CustomLoaderForm from "../../../components/CustomLoaderForm";
import { useGetCarriers } from "../Carrier/hooks/useGetCarriers";
import { useLobTypeOptions } from "./hooks/useLobTypeOptions";
import { useGetProdType } from "./hooks/useProducerCodeType";
import { useDistributionChannelOptions } from "./hooks/useDistributionChannelOptions";
import { isForFranchiseDataState } from "./atoms/atoms";
import { useRecoilValue } from "recoil";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useCarrierProducerCodeList } from "./hooks/useGetCarrierProdCode";
const AddProducersMainForm = ({
  data,
  Cancel,
  handleTextBoxChange,
  handleMultiStateSelect,
  handleRemovecarrierAddress,
  handleAddcarrierProducerCodeRow,
  handleProducerCodeInputs,
  carrierProducerCodeData,
  handleAddProducerCodeRow,
  handleRemoveProducerCodeRow,
  carrierContactTypes,
  addStatus,
  handleClickSave,
  addMainForm,
  clearAddForm,
  setCarriers,
  saveDisabled,
  handleMACheckBox,
  handleIsFranchise,
  saveModal,
  setSaveModal,
  buttonText,
  groupedProducerCodes,
  setcarrierProducerCodeData,
  carrierProducerCodeRow,
}) => {
  const { data: allProducerCodeList } =
    useCarrierProducerCodeList(groupedProducerCodes);
  const user = useRecoilValue(accountAtom);
  const { data: agenciesQuery, isFetching: isLoading } = useSFGetOffice();
  const agencies =
    agenciesQuery &&
    agenciesQuery
      .filter((x) => x.officeCode !== null && x.officeCode !== "")
      .map((resData) => ({
        label: resData.officeName + "-" + resData.officeCode,
        value: resData.officeCode + "-" + resData.storeNumber,
        state: resData.stateCode,
        isFranchise: resData.isFranchise,
        officeType: resData.officeType,
      }));
  const isFranchise = useRecoilValue(isForFranchiseDataState);
  const { data: carriersQuery, isFetching: carrierLoading } = useGetCarriers();
  const carriers = carriersQuery
    ?.filter((ca) => ca.isActive === true)
    .map((x) => {
      return {
        label: x.carrierName,
        value: x.masterCarrierId,
      };
    });
  const { data: LOBQuery } = useLobTypeOptions();
  const loboptions =
    LOBQuery &&
    LOBQuery.filter((data) => data.isActive === true).map((resData) => ({
      label: resData.lobname,
      value: resData.lobid,
    }));
  const { data: prodTypeQuery } = useGetProdType();
  const prodtypeoptions =
    prodTypeQuery &&
    prodTypeQuery
      .filter((data) => data.isActive === true)
      .map((resData) => ({
        label: resData.producerCodeTypesName,
        value: resData.producerCodeTypesId,
      }));
  const { data: distChannel } = useDistributionChannelOptions();
  const distChannelOpts = distChannel
    ?.filter(
      (dist) =>
        dist.isActive === true &&
        (user?.isNonFranchise && user?.isFranchise
          ? dist.distributionChannelName !== null
          : user?.isFranchise
          ? dist.distributionChannelName !== null
          : dist.distributionChannelName !== "Franchise")
    )
    .map((x) => {
      return {
        label: x.distributionChannelName,
        value: x.distributionChannelId,
      };
    });

  return (
    <>
      <div className="animate-fade-in-down1 pt-2 box-shadow border-quinary border-l-2">
        <div className="">
          <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
            <div className="ml-2 font-bold text-primary text-md">
              Add{isFranchise ? " Franchise" : ""} Producer Codes
            </div>
            <div className="flex justify-between gap-2 mr-2">
              <SaveButton
                className={saveDisabled ? "opacity-50" : "opacity-100"}
                onClick={() => setSaveModal(true)}
                disabled={saveDisabled}
                buttonText={buttonText}
              />
              <CancelButton buttonText="Cancel" onClick={Cancel} />
            </div>
          </div>{" "}
          {isLoading || carrierLoading ? (
            <CustomLoaderForm />
          ) : (
            <>
              <div className="w-full border-b-2 border-secondary"></div>
              <div className="text-xs text-secondary italic font-normal mt-2 ml-2">
                <b> Note:</b> All fields with * are required to fill.
              </div>
              <div className="w-full">
                <div className="">
                  <ProdCodeFormCarrierSection
                    tableName="ProducerAddressTable"
                    hideActionColumn={false}
                    addStatus={addStatus}
                    carriers={carriers}
                    agencies={agencies}
                    data={data}
                    loading={isLoading}
                    state={data == null ? "" : data.state}
                    carrierProducerCodeData={carrierProducerCodeData}
                    handleMultiSelect={handleMultiStateSelect}
                    carrierContactTypes={carrierContactTypes}
                    handleAddcarrierProducerCodeRow={
                      handleAddcarrierProducerCodeRow
                    }
                    handleRemovecarrierAddress={handleRemovecarrierAddress}
                    handleProducerCodeInputs={handleProducerCodeInputs}
                    handleAddProducerCodeRow={handleAddProducerCodeRow}
                    handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
                    handleTextBoxChange={handleTextBoxChange}
                    loboptions={loboptions}
                    prodtypeoptions={prodtypeoptions}
                    distChannelOpts={distChannelOpts}
                    addMainForm={addMainForm}
                    clearAddForm={clearAddForm}
                    setCarriers={setCarriers}
                    handleMACheckBox={handleMACheckBox}
                    handleIsFranchise={handleIsFranchise}
                    saveModal={saveModal}
                    setSaveModal={setSaveModal}
                    allProducerCodeList={allProducerCodeList}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="hidden sm:block" aria-hidden="true"></div>
        <ConfirmBoxModal
          ModalTitle="Add Producer"
          qConfirmation=" Are you sure you want to add this data?"
          isOpen={saveModal}
          onClose={() => {
            setSaveModal(false);
            // setcarrierProducerCodeData([carrierProducerCodeRow]);
          }}
          onClickFunction={() => handleClickSave()}
        />
      </div>
    </>
  );
};

export default AddProducersMainForm;
